import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/contexts/ToastContext";
import { installRestrictedToast } from "@/lib/restricted";

// Mounts once: any scoped-ban refusal not shown inline becomes a plain toast.
export const RestrictedToast = () => {
  const toast = useToast();
  const { t } = useTranslation();
  useEffect(() => { installRestrictedToast((m) => toast.error(m), t); }, [toast, t]);
  return null;
};

export default RestrictedToast;
